/**
*  Get Block Column.
*
* @param {String} colClassName ClassName
* @returns {Array} Block column.
*/
const ALLOWED_BLOCKS = [ 'core/paragraph', 'core/heading', 'core/list',  'core/quote', 'core/table']
const getBlockColumn = ( colClassName, colInnerClass, colWidth ) => {
return [
	'core/column',	{ 
		className: colClassName,
		width: colWidth,


	},
	[
		[
			'core/group',
			{
				className: colInnerClass,
				allowedBlocks: ALLOWED_BLOCKS,
				attributes: {
					// Prevent a block from being moved or removed.
					lock: {
					  remove: true,
					  move: true,
					}
				  }
			},
		],
	]
];
};

export const blockColumns = [
[
	'core/columns',
	{
		className: 'page__content -text',

		align: 'full'
		
	},
	[
		getBlockColumn( 'page__content-text text', '', '70%' ),
		getBlockColumn( 'page__content-sidebar', 'page__content-sidebar-content text', '30%' )
	]
],
];